import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { ICustomViewInfo } from '../../../../ts/ServerApi/CustomViews/ICustomViewInfo';
import { IDeleteAction as IDeleteActionApi } from '../../../../ts/ServerApi/types/actionNames';
import { deleteCustomView } from '../../../actions/spaces/customViews/DeleteCustomViewAction';
import { selectSpaceInfoItem } from '../../../selectors/SpaceInfoSelectors';
import { AppState } from '../../../state/AppState';
import { currentUserIsOwnerOrAdmin } from '../../../utils/MixedContentHelpers';
import { EntityActionNames, IEntityAction } from './IEntityAction';


export const DeleteCustomViewAction: IEntityAction<ICustomViewInfo, IDeleteActionApi> = {
  name: EntityActionNames.DeleteCustomView,
  translateName: Messages.delete_action,
  isVisible: () => {
    return FeatureFlags.showCustomViewsForWorkbookEnabled;
  },
  isClickable: isClickable,
  createReduxAction: deleteCustomView
};

function isClickable(
  availableActions: IDeleteActionApi,
  customView: ICustomViewInfo[],
  state: AppState
): boolean {
  const spaceItem = selectSpaceInfoItem(state);
  return currentUserIsOwnerOrAdmin(state, spaceItem);
}
